export default __webpack_public_path__ + "static/media/register.67380358.png";